import axios from 'axios'

const baseURL = process.env.VUE_APP_PRODUCT_SERVICE + '/api/systems'
const orderURL = process.env.VUE_APP_ORDER_SERVICE + '/api/state'
const dropURL = process.env.VUE_APP_DROP_ORDER_SERVICE + '/api/admin/state'
const inetURL = process.env.VUE_APP_INET_ORDER_SERVICE + '/api/v2/admin/state'

export default {
  namespaced: true,
  state: {
    system_logs: null
  },
  mutations: {
    setSystemLogs (state, value) {
      state.system_logs = { ...state.system_logs, ...value }
    }
  },
  actions: {
    async getLogs ({
      commit
    }) {
      const promise = axios.get(baseURL)
      promise.then(response => {
        commit('setSystemLogs', response.data.data)
      })
      axios.get(orderURL).then(response => {
        commit('setSystemLogs', response.data)
      })
      axios.get(dropURL).then(response => {
        commit('setSystemLogs', response.data)
      })
      axios.get(inetURL).then(response => {
        commit('setSystemLogs', response.data)
      })

      return promise
    }
  }
}
